import Toast from 'bootstrap/js/dist/toast'
let container: HTMLElement | null = null
function ensure_container(): HTMLElement {
  if (container && document.body.contains(container)) return container
  container = document.getElementById('toast-container')
  if (!container) {
    container = document.createElement('div')
    container.id = 'toast-container'
    container.className = 'toast-container position-fixed top-0 start-0 p-3'
    container.style.zIndex = '9999'
    document.body.appendChild(container)
  }
  return container
}
export function toast(message: string | object, type = 'danger'): void {
  const msg = typeof message === 'object' ? `<code>${JSON.stringify(message, null, 2)}</code>` : message
  if (type === 'danger' || type === 'error') console.error('%c' + msg, 'color: #dc3545; font-weight: bold;')
  else if (type === 'warning') console.warn('%c' + msg, 'color: #ffc107; font-weight: bold;')
  else if (type === 'success') console.log('%c' + msg, 'color: #198754; font-weight: bold;')
  else if (type === 'info') console.info('%c' + msg, 'color: #0dcaf0; font-weight: bold;')
  else if (type === 'dark') console.log('%c' + msg, 'color: #6c757d; font-weight: bold;')
  else console.log(msg)
  const bs_type = type === 'error' ? 'danger' : type
  const toast_id = 'toast-' + Date.now()
  const el = document.createElement('div')
  el.id = toast_id
  el.className = `toast align-items-center text-bg-${bs_type} border-0`
  el.setAttribute('role', 'alert')
  el.setAttribute('aria-live', 'assertive')
  el.setAttribute('aria-atomic', 'true')
  el.innerHTML = `<div class="d-flex"><div class="toast-body">${msg}</div><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div>`
  ensure_container().appendChild(el)
  const instance = new Toast(el, { delay: 5000 })
  instance.show()
}
export const green = (_id: string, str: string) => toast(str, 'success')
export const red = (_id: string, str: string) => toast(str, 'danger')
export const yellow = (_id: string, str: string) => toast(str, 'warning')
export const blue = (_id: string, str: string) => toast(str, 'info')
export const warning = (msg: string) => toast(msg, 'warning')
export const error = (msg: string) => toast(msg, 'danger')
export const danger = (msg: string) => toast(msg, 'danger')
export const success = (msg: string) => toast(msg, 'success')
export const info = (msg: string) => toast(msg, 'info')
export const debug = (msg: string) => toast(msg, 'dark')
